module.exports = __webpack_public_path__ + "static/partner-quote-background-a95790ffbf814d399edee44e50b8f558.png";